export const HISTORY_SINGLE_VIEWS = [
	{
		path: 'quote',
		name: 'enterprise_quote'
	},
	{
		path: 'quarterly_performance',
		name: 'enterprise_quarterly_performance'
	},
	{
		path: 'investment_activity',
		name: 'enterprise_investment_activity'
	},
	{
		path: 'announcement',
		name: 'enterprise_announcement'
	},
	{
		path: 'question',
		name: 'enterprise_question'
	},
	{
		path: 'news',
		name: 'enterprise_news'
	},
	{
		path: 'report',
		name: 'enterprise_report'
	},
	{
		path: 'custom',
		name: 'enterprise_custom'
	},
	{
		path: 'customs_calendar',
		name: 'enterprise_customs_calendar'
	},
	{
		path: 'esg',
		name: 'enterprise_esg'
	},
	{
		path: 'analyst',
		name: 'enterprise_analyst'
	},
	{
		path: 'performance_report',
		name: 'enterprise_performance_report'
	},
	{
		path: 'corporate_governance',
		name: 'enterprise_corporate_governance'
	},
	{
		path: 'finance_data',
		name: 'enterprise_finance_data'
	},
	{
		path: 'us_announcement',
		name: 'enterprise_us_announcement'
	}
];
